
import { addToChainAfter, createHandlerChainRunner, HandlerWithResult } from "@insite/client-framework/HandlerCreator";
import { chain,RemoveStockedItemsFilter } from "@insite/client-framework/Store/Pages/ProductList/Handlers/RemoveProductFilters";
import { ProductFilters } from "@insite/client-framework/Store/Pages/ProductList/ProductListState";
import { CustomProductFilters } from "@tSurya/Handlers/ProductList/AddProductAvailibility";

type HandlerType = HandlerWithResult<CustomProductFilters, CustomProductFilters>;

export const RemoveProductAvailibility: HandlerType = ({ result, parameter: { minimumPrice } }) => {
    if (minimumPrice !== undefined) {
        result.minimumPrice = undefined;
    }
};



addToChainAfter(chain,RemoveStockedItemsFilter,RemoveProductAvailibility);